//smooth scrolling

$(document).ready(function() {
    //link example
    //<a href="#value" class="flowing-scroll">link</a>

    $('.flowing-scroll > a').on('click', function H() {
        let el = $(this),
            dest = el.attr('href');
        let destId = dest.slice(dest.indexOf('#'));

        if(destId !== undefined && destId !== '' && $(destId).offset() !== undefined ) {
            $('html').animate(
                { scrollTop: $(destId).offset().top }, 1000 // speed
            );
        }
    });
});
